import worldMapData from '@highcharts/map-collection/custom/world.geo.json';

import Highcharts from 'highcharts';
import exporting from 'highcharts/modules/exporting';
import mapInit from 'highcharts/modules/map';
import HighchartsVue from 'highcharts-vue';

import MerchantProductRedemptions from "../../../../../../resources/portal/reports/views/reports/merchantProductRedemptions";
import VenuePayments from "../../../../../../resources/portal/reports/views/reports/venuePayments";

mapInit(Highcharts);
Highcharts.maps.world = worldMapData;
exporting(Highcharts);

window.Vue.use(HighchartsVue);

window.Vue.component('MerchantProductRedemptions', MerchantProductRedemptions);
window.Vue.component('VenuePayments', VenuePayments);